// TODO: move following definitions to a root level file.

// status string used by CoUpload component.
export const UPLOAD_STATUSES = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  ERROR: 'ERROR',
};

export const DOCUMENT_STATUSES = {
  DOCUMENT_TODO: 'DOCUMENT_TODO',
  DOCUMENT_IN_PROGRESS: 'DOCUMENT_IN_PROGRESS',
  DOCUMENT_SUBMITTED: 'DOCUMENT_SUBMITTED',
  DOCUMENT_APPROVED: 'DOCUMENT_APPROVED',
  DOCUMENT_RESET: 'DOCUMENT_RESET',
  DOCUMENT_UNKNOWN_STATUS: 'DOCUMENT_UNKNOWN_STATUS',
};

export const DOWNLOAD_DOCUMENT_TYPES = {
  FORM: 'form',
  DOCSIGN: 'signed',
};

export const COMPLETION_PERCENTAGES = {
  COMPLETE: 100,
  INCOMPLETE: 0,
};
